// Libraries
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';

// Components
import StateScreen from './StateScreen';

/**
 * @function ErrorUndefined
 * Describe the component's function
 *
 * @example
 * return (
 *   <ErrorUndefined error='' />
 * )
 */
function ErrorUndefined({ error }: ErrorUndefinedProps): JSX.Element {
    return (
        <StateScreen
            icon={<FontAwesomeIcon icon={faTriangleExclamation} />}
            title={`Sorry, ${error.toLowerCase()}`}
        >
            <p>Please check back soon and try again.</p>
        </StateScreen>
    );
}

/**
 * @interface ErrorUndefinedProps
 * Describes the properties required for the ErrorUndefined component
 *
 * @property {string} error Current position in draw sequence
 */
export interface ErrorUndefinedProps {
    error: string;
}

// Exports
export default ErrorUndefined;
